import * as actionType from "../types/ActionTypes";

const initialState = {
  teachers: [],
  postTeachers: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Teachers = (state = initialState, action) => {
  switch (action.type) {
    case actionType.TEACHERS_SET_DATA:
      return {
        ...state,
        teachers: action.teachers,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.TEACHERS_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.TEACHERS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.TEACHERS_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.TEACHERS_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_TEACHERS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_TEACHERS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postTeachers: action.postTeachers,
      };
    case actionType.UPDATE_TEACHERS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_TEACHERS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_TEACHERS_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
